"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _auth = require("@/utils/auth");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'upload',
  props: {
    value: '',
    limit: {
      type: Number,
      default: 1
    },
    multiple: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      default: 'Image/uploadImage'
    },
    ratio: {
      type: String,
      default: ''
    },
    raw: {
      type: Boolean,
      default: false
    },
    uploadText: {
      type: String,
      default: ''
    },
    emitUrl: {
      type: Boolean,
      default: true
    },
    upObj: {
      type: Object,
      default: function _default() {
        return {
          user_id: (0, _auth.getToken)('user_id'),
          agent_id: (0, _auth.getToken)('agent_id'),
          token: (0, _auth.getToken)()
        };
      }
    }
  },
  data: function data() {
    return {
      baseURL: this.config.BASE_URL,
      dialogImageUrl: '',
      dialogVisible: false,
      percentage: 1,
      rawUrl: ''
    };
  },
  methods: {
    /**
     * 图片上传之前
     */
    beforeUpload: function beforeUpload(file) {
      if (this.raw) {
        var rawUrl = null;
        if (window.createObjectURL != undefined) {
          // basic
          rawUrl = window.createObjectURL(file);
        } else if (window.URL != undefined) {
          // mozilla(firefox)
          rawUrl = window.URL.createObjectURL(file);
        } else if (window.webkitURL != undefined) {
          // webkit or chrome
          rawUrl = window.webkitURL.createObjectURL(file);
        }
        this.rawUrl = rawUrl;
        this.$emit('getFile', file);
        return false;
      }
    },
    /**
     * 图片上传调用接口成功 但上传不一定成功
     */
    handleSuccess: function handleSuccess(res, file, fileList) {
      if (res.data.code > 0) {
        file.status = 'error';
        this.$message.error("\u56FE\u7247\u4E0A\u4F20\u5931\u8D25:".concat(res.data.message, ", \u8BF7\u5220\u9664\u5931\u8D25\u7684\u56FE\u7247\u91CD\u65B0\u4E0A\u4F20"));
      } else {
        if (res.data.file_url) fileList[fileList.length - 1].url = res.data.file_url;
        if (res.data.media_id) fileList[fileList.length - 1].media_id = res.data.media_id;
        this.update(fileList);
      }
    },
    /**
     * 移除图片
     * @param {Object} file
     * @param {Object} fileList
     */
    handleRemove: function handleRemove(file, fileList) {
      if (file.status == 'success') {
        this.update(fileList);
      }
    },
    /**
     * 预览图片
     * @param {Object} file
     */
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    /**
     * 文件超出限制
     */
    exceed: function exceed(files, fileList) {
      this.$message.error("\u6700\u591A\u53EF\u4E0A\u4F20".concat(this.limit, "\u4E2A\u6587\u4EF6"));
    },
    update: function update(fileList) {
      if (this.limit == 1 && this.emitUrl) {
        var l = fileList.length;
        this.$emit('input', fileList[l] ? fileList[l].url : fileList[0].url);
      } else {
        this.$emit('input', fileList);
      }
    }
  }
};